<template>
    <div class="test-comment is-reply" v-if="!reply.deleted">
        <div class="test-comment-avatar" :class="{'no-avatar': !reply.avatar}">
            <img :src="reply.avatar" :alt="reply.author" v-if="reply.avatar">
            <icon-user v-else/>
        </div>
        <div class="test-comment-content">
            <div class="test-comment-main" :class="{'is-edit': replyIsEdit, 'edited': reply.edited}">
                <div class="test-comment-header flex-v-center" v-if="!replyIsEdit">
                    <div class="flex-v-center test-comment-header-content">
                        <div class="test-comment-author">{{ reply.author }}</div>
                        <div class="test-comment-date"> {{ timeAgo(reply.edited_at ? reply.edited_at : reply.created_at) }}</div>
                    </div>
                    <TestCommentOptions v-if="checkEditRemoveAvailable( reply.edited_at || reply.created_at)"
                                        :comment-id="reply.id" @edit="showEditReply(reply.id)" @remove="$emit('showremove', reply)"/>
                </div>
                <TestCommentEditor :edit-comment="true" :comment="reply.comment"
                                   @addcomment="editReply" v-if="replyIsEdit" @cancel="replyIsEdit = false"/>
                <div v-else class="test-comment-text">
                    <span v-html="reply.comment"></span>
                    <span v-if="reply.edited_at" class="test-comment-edited-label">(відредаговано)</span>
                </div>
            </div>
            <div class="test-comment-footer">
                <div class="test-comment-like flex-v-center" @click="$emit('setvote', reply.id, 1)">
                    <icon-comment-like/>
                    {{ reply.good_votes }}
                </div>
                <div class="test-comment-dislike flex-v-center" @click="$emit('setvote', reply.id, 0)">
                    <icon-comment-dislike/>
                    {{ reply.bad_votes }}
                </div>
                <div class="test-comment-reply flex-v-center" v-if="store.user && store.user.id" @click="$emit('showreply')">
                    <icon-share class="test-comment-reply-icon"/>
                    Відповісти
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconCommentLike from '../../icons/IconCommentLike.vue';
import IconCommentDislike from '../../icons/IconCommentDislike.vue';
import IconShare from '../../icons/IconShare.vue';
import TestCommentEditor from './TestCommentEditor.vue';
import IconUser from '../../icons/IconUser.vue';
import TestCommentOptions from './TestCommentOptions.vue';
import {timeAgo} from '../../helpers/helperFunctions';
import {tourniquetStore} from "../../../store/store";

export default {
    name: "TestCommentReply",
    components: {
        TestCommentOptions, IconUser, TestCommentEditor, IconShare, IconCommentDislike, IconCommentLike},
    props: ['reply'],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    data() {
        return {
            replyIsEdit: false,
            replyCommentId: null,
        }
    },
    methods: {
        checkEditRemoveAvailable(createdTime) {
            const createdTimeMinutes = Math.floor(new Date(createdTime).getTime() / (1000 * 60));
            const timeNowMinutes = Math.floor(new Date(Date.now()).getTime() / (1000 * 60));
            return timeNowMinutes - createdTimeMinutes < 30
        },
        editReply(comment) {
            this.$emit('editreply', comment, this.reply.id);
            this.replyIsEdit = false;
        },
        showEditReply(id) {
            this.replyIsEdit = true;
            this.$emit('seteditreplyid', id)
        },
        timeAgo
    }
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/front/helpers";

.test-comment {
    &-main {
        padding: 1.4rem 2rem;
        border-radius: 1.2rem;
        background-color: #fff;
        margin-bottom: 1rem;

        &.is-edit {
            padding: 0;
        }
        &.edited {
            background: linear-gradient(94.37deg, rgba(67, 122, 252, 0.05) -1.35%, rgba(248, 228, 47, 0.05) 97.02%);
        }
    }
}

</style>
